import { render } from "./HeroiconsOutlineFire.vue?vue&type=template&id=4822ea48"
const script = {}

import exportComponent from "/home/fran/Desarrollo/soyasi/ebim-crm/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineFire.vue"]])

export default __exports__